import { HowItWorksCardContainer } from './components/HowItWorksCardContainer';
import { HowItWorksCardText } from './components/HowItWorksCardText';
import { HowItWorksCardTitle } from './components/HowItWorksCardTitle/HowItWorksCardTitle';

export const HowItWorksCard = {
  Container: HowItWorksCardContainer,
  Title: HowItWorksCardTitle,
  Text: HowItWorksCardText,
};
